import { scaleLinear } from 'd3-scale';

export const calculateMinAndMaxValues = data => ({
  min: Math.min(...data),
  max: Math.max(...data)
});

export const applyNiceOnDomain = domain => scaleLinear().domain(domain).nice().domain();

export const calculateDomains = data => {
  const average = calculateMinAndMaxValues(data.map(item => item.average));
  const median = calculateMinAndMaxValues(data.map(item => item.median));

  if (Math.min(average.min, median.min) < 0 && Math.max(average.max, median.max) > 0) {
    const averageAbsMaxValue = Math.max(Math.abs(average.min), Math.abs(average.max));
    const medianAbsMaxValue = Math.max(Math.abs(median.min), Math.abs(median.max));

    return {
      average: applyNiceOnDomain([-averageAbsMaxValue, averageAbsMaxValue]),
      median: applyNiceOnDomain([-medianAbsMaxValue, medianAbsMaxValue])
    };
  }

  return {
    average: applyNiceOnDomain([Math.min(0, average.min), Math.max(0, average.max)]),
    median: applyNiceOnDomain([Math.min(0, median.min), Math.max(0, median.max)])
  };
};
